import {Euler, type Group, type Mesh, Quaternion, Vector4} from 'three'

import type {BrandedDividerParams} from '../../../../components/WebGLContext/WebGLContext.types'
import BaseMona from './BaseMona'

export default class Mona2 extends BaseMona {
  constructor(params: BrandedDividerParams, rectData: Vector4) {
    super(params, rectData)

    const scale = 0.12
    this.group.scale.set(scale, scale, scale)
  }

  override createTl(): void {
    this.tl.add(() => {
      this.group.visible = true
    }, 0)

    // Eye animation
    const eyeGroup = this.group.getObjectByName('EyeGroup') as Group
    const mirroredEyeGroup = this.group.getObjectByName('EyeGroup_mirrored') as Group
    if (eyeGroup && mirroredEyeGroup) {
      const y = 0.4
      this.tl
        .fromTo(
          eyeGroup.position,
          {
            y,
          },
          {
            y: 0,
            ease: 'expo.out',
            duration: 3,
          },
          0.5,
        )
        .fromTo(
          mirroredEyeGroup.position,
          {
            y,
          },
          {
            y: 0,
            ease: 'expo.out',
            duration: 3,
          },
          0.5,
        )
    }

    const createWhiskerAnimation = (group: Mesh[], sign: number) => {
      group.forEach((mesh, index) => {
        const duration = 0.5
        const step = 0.0
        this.tl
          .to(
            mesh.rotation,
            {
              z: -0.4 * sign,
              duration,
              // repeatDelay: 0.5,
            },
            index * step,
          )
          .to(
            mesh.rotation,
            {
              z: 0.25 * sign,
              duration,
              // repeatDelay: 0.5,
            },
            duration + index * step,
          )
          .to(
            mesh.rotation,
            {
              z: -0.1 * sign,
              duration,
              // repeatDelay: 0.5,
            },
            duration * 2 + index * step,
          )
          .to(
            mesh.rotation,
            {
              z: 0.1 * sign,
              duration,
              // repeatDelay: 0.5,
            },
            duration * 3 + index * step,
          )
          .to(
            mesh.rotation,
            {
              z: 0,
              duration,
              // repeatDelay: 0.5,
            },
            duration * 4 + index * step,
          )
      })
    }

    // Whiskers animation
    createWhiskerAnimation(this.whiskers.original, 1)
    createWhiskerAnimation(this.whiskers.mirrored, -1)

    // Group animation
    this.group.rotation.order = 'ZXY'
    this.group.userData.rotation = this.group.rotation.clone()
    this.group.position.x = 4.65
    this.tl
      .fromTo(
        this.group.position,
        {
          y: -2,
        },
        {
          y: -0.1,
          duration: 2,
          ease: 'elastic.out(1, 1)',
        },
        0,
      )

      .fromTo(
        this.group.userData.rotation,
        {
          y: Math.PI * 1.5,
        },
        {
          y: -Math.PI * 0.14,
          duration: 1.5,
          ease: 'expo.out',
        },
        0,
      )
      .fromTo(
        this.group.userData.rotation,
        {
          x: -Math.PI * 0.1,
        },
        {
          x: Math.PI * 0.08,
          duration: 3,
          ease: 'expo.out',
        },
        0,
      )

    super.createTl()
  }

  override update(scrollProgress: number): void {
    if (!this.group.userData.rotation) return
    const euler = new Euler(-scrollProgress * 0.3, 0, 0)
    const quaternion = new Quaternion().setFromEuler(euler)
    this.group.quaternion.setFromEuler(this.group.userData.rotation)
    this.group.quaternion.multiply(quaternion)
  }
}
